import React, { useEffect, useReducer } from 'react';
import Grid from '@material-ui/core/Grid';
import { useHistory } from "react-router-dom";
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import { ErrorBoundary } from 'react-error-boundary'

import SurveyQuestionContext from '../../../context/surveyquestion-context';
import surveyQuestionReducer from '../../../reducers/surveyQuestion-reducer';
import Loading from '../../shared/Loading'
import { getQuestion } from '../../../actions/survey-actions';
import { getStudentCoins } from '../../../actions/share-actions';
import SurveyQuestionHolder from './SurveyQuestionHolder'
import { DefaultLayout, BreadcrumbsCustom, ProgressBarSurvey, Coin } from '../../shared/component'
import ErrorFallback from '../../shared/ErrorFallback'

import { SnapShotSurveyData, StudentProfile } from '../../../utils/services/cache/ClientCache'
import { getIconSurvey } from '../../../utils/helpers/icon/iconHelper';
import useStyles from "../../../styles/components/survey/stylesSurvey";


function sortAnswer(answers) {
    answers.sort(function (a, b) { return a.orderNumber - b.orderNumber });
    return answers;
}

const SurveyQuestionList = () => {
    const history = useHistory();
    const classes = useStyles();
    const [surveyQuestionContext, dispatch] = useReducer(surveyQuestionReducer);
    const [loading, setLoading] = React.useState(true);
    const survey = JSON.parse(SnapShotSurveyData.getSurveyProcessBar());

    let title = SnapShotSurveyData.getSnapshotSurveyName();
    let id = SnapShotSurveyData.getSnapshotSurveyId();

    if (!id) return <Loading />;

    useEffect(() => {
        initStudentCoins();
        initSurveyQuestionList();
        setLoading(false);
    }, []);

    const initSurveyQuestionList = async () => {

        let response = await getQuestion(id);
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }

        let questionList = response.data;
        dispatch({ type: 'SET_QUESTION_LIST', questionList });

        if (questionList.subTraitId !== null) // trait survey section
        {
            dispatch({ type: 'SET_IS_TRAITSURVEY', isTraitSurvey: true });

            dispatch({ type: 'SET_RESULT_LOGIC', resultLogics: questionList.surveyResultLogics });

            let maxScore = 0;
            let subtraitsMaxScoreList = [];
            let subtraitsMaxScoreDictionary = {};

            dispatch({ type: 'SET_MAXSCORE', maxScore: maxScore });
            dispatch({ type: 'SET_SUBTRAITS_MAXSCORE_DICTIONARY', subtraitsMaxScoreDictionary: subtraitsMaxScoreDictionary });
            dispatch({ type: 'SET_SUBTRAITS_MAXSCORE_LIST', subtraitsMaxScoreList: subtraitsMaxScoreList });
        }

        let header = '';
        let freeText = [];
        let _scaleContents = [];
        let _scaleAnswers = [];
        let _multipleChoiceContents = [];
        let _multipleChoiceAnswers = [];
        let _checkboxContents = [];
        let _checkboxAnswerDictionary = {};
        let _rankingContents = [];
        let _rankingAnswers = [];
        let _seletionLimit = 0;
        let answers;
        let hoverList = [];
        let answersSort = [];

        questionList.map((surveyQuestion) => {
            switch (surveyQuestion.questionTypeId) {
                case 5: //"Section Text"
                    header = surveyQuestion.questionContent
                    break;
                case 3: //"Scale"
                    let hover = -1;
                    hoverList.push(hover)
                    answersSort = sortAnswer(surveyQuestion.scaleQuestionOptionModels)
                    let scaleContent = {
                        type: 'Scale',
                        question: surveyQuestion,
                        answers: answersSort,
                        selectedAnswer: {},
                        hoverList: hoverList,
                    }
                    _scaleContents.push(scaleContent);
                    break;
                case 2: //"Multiple Choices"
                    answersSort = sortAnswer(surveyQuestion.questionOptionModels);
                    let multipleChoiceContent = {
                        type: 'MultipleChoice',
                        question: surveyQuestion,
                        answers: answersSort,
                        selectedAnswer: {}
                    }
                    _multipleChoiceContents.push(multipleChoiceContent);
                    break;
                case 4: //"Checkbox"
                    answers = sortAnswer(surveyQuestion.questionOptionModels);
                    answers.map(item => {
                        item.isChecked = false
                        return item
                    })
                    _seletionLimit = parseInt(surveyQuestion.checkboxLimit) < 0 ? 0 : parseInt(surveyQuestion.checkboxLimit);
                    _checkboxAnswerDictionary[answers[0].id] = surveyQuestion.questionOptionModels[0].questionOptionContent;
                    let checkboxContent = {
                        type: 'Checkbox',
                        question: surveyQuestion,
                        answers: answers,
                        seletionLimit: _seletionLimit,
                        checkboxAnswerDictionary: []
                    }
                    _checkboxContents.push(checkboxContent);
                    break;
                case 6: //"Ranking"
                    answersSort = sortAnswer(surveyQuestion.questionOptionModels);
                    let rankingChoiceContent = {
                        type: 'Ranking',
                        question: surveyQuestion,
                        answers: answersSort,
                        selectedAnswer: {}
                    }
                    _rankingContents.push(rankingChoiceContent);
                    break;
                case 1: //"Free Text"
                    let _freeText = {
                        type: 'FreeText',
                        title: surveyQuestion.questionContent,
                        questionId: surveyQuestion.id,
                        input: ''
                    }
                    freeText.push(_freeText)
                    break;
                default:
                    break;
            }
        });

        dispatch({ type: 'SET_HEADER', header: header });
        dispatch({ type: 'SET_FREETEXT', freeText: freeText });
        dispatch({ type: 'SET_SCALE_CONTENTS', scaleContents: _scaleContents });
        dispatch({ type: 'SET_SCALE_ANSWERS', scaleAnswers: _scaleAnswers });
        dispatch({ type: 'SET_MULTIPLECHOICE_CONTENTS', multipleChoiceContents: _multipleChoiceContents });
        dispatch({ type: 'SET_MULTIPLECHOICE_ANSWERS', multipleChoiceAnswers: _multipleChoiceAnswers });
        dispatch({ type: 'SET_CHECKBOX_CONTENTS', checkboxContents: _checkboxContents });
        dispatch({ type: 'SET_RANKING_CONTENTS', rankingContents: _rankingContents });
        dispatch({ type: 'SET_RANKING_ANSWERS', rankingAnswers: _rankingAnswers });
    };

    const initStudentCoins = async () => {
        const response = await getStudentCoins();
        if (response.status === "Success") {
            StudentProfile.setRewardPoint(response.data);
        }
    };

    const breadcrumbsData = [
        {
            type: 'Survey',
            text: 'Survey Overview',
            href: '/Survey'
        },
        {
            type: 'Survey',
            text: title,
            href: ''
        },
    ];

    if (loading) return <Loading />;

    return (
        <SurveyQuestionContext.Provider value={{ surveyQuestionContext, dispatch }}>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
                <DefaultLayout
                    title={title}
                    type='Survey'
                    image={getIconSurvey().img_survey_bg}
                    progressBar={
                        <>
                            <Grid container
                                direction="column"
                                justify="space-between"
                                alignItems="center" classes={{ root: classes.rootGridInfoProgress }}>
                                <Typography variant="body2" classes={{ root: classes.rootTypographyHeader }} style={{ margin: '-20px 0px 10px 0px' }}>
                                    {survey.date}
                                </Typography>
                                <Hidden smDown>
                                    <Coin coin={survey.coin} size="medium" />
                                </Hidden>
                                <Hidden mdUp>
                                    <Coin coin={survey.coin} size="small" />
                                </Hidden>
                            </Grid>
                        </>
                    }
                >
                    <Grid container>
                        <Grid item xs={3} classes={{ root: classes.rootGridTabsContainer }}></Grid>
                        <Grid item xs={12} sm={12} md={6} lg={5} classes={{ root: classes.rootGridContentContainer }}>
                            <br />
                            <BreadcrumbsCustom breadcrumbsData={breadcrumbsData} />
                            <SurveyQuestionHolder />
                        </Grid>
                    </Grid>
                </DefaultLayout>
            </ErrorBoundary>
        </SurveyQuestionContext.Provider>
    );
};

export default SurveyQuestionList;

//<ProgressBarSurvey
//    progressPercent={survey.progressPercent}
//    milestonePercent={survey.milestonePercent}
//    bonusPoint={survey.bonusPoint}
//    noreward={survey.noreward}
//    missed={survey.missed}
//    toolTipCoin={false}
//    position={survey.position}
//    isHeader={true}
///>

//<Typography variant="body2" classes={{ root: classes.rootTypographyHeader }}>
//    Survey Completion Progress: {survey.progressPercent}%
//</Typography>